import {
  createAiConversation,
  fetchAiStatus,
  sendAiMessage,
  updateAiConversation,
} from '../assistant/assistantApi';

export async function fetchTrainerAvailable() {
  const status = await fetchAiStatus();
  return Boolean(status?.enabled);
}

export async function createTrainingConversation({ tenantId, pins }) {
  return createAiConversation({
    mode: 'training',
    tenantId,
    pins,
  });
}

export async function askTrainingQuestion({
  conversationId,
  tenantId,
  message,
  pins,
  onEvent,
}) {
  if (pins) {
    await updateAiConversation({ conversationId, tenantId, pins });
  }
  return sendAiMessage({
    conversationId,
    tenantId,
    message,
    onEvent,
  });
}

export function buildStepPins({
  procedureId,
  stepId,
  stepNumber,
  stepText,
  moduleId,
  rolePath,
  lessonTitle,
}) {
  return {
    procedureId,
    stepId,
    stepNumber: stepNumber != null ? String(stepNumber) : undefined,
    stepText,
    moduleId,
    rolePath,
    lessonTitle,
    trainingIntent: 'qa',
  };
}
